// extracted by mini-css-extract-plugin
export default {"Main":"OptionCardImg_Main__Y3260","Children":"OptionCardImg_Children__Uf1lA","NameDownload":"OptionCardImg_NameDownload__lMe0-","Target":"OptionCardImg_Target__FgLjh"};